import { Page } from '@tunasong/icons'
import { useElementTypeMedia } from '@tunasong/plugin-lib'
import type { Entity } from '@tunasong/schemas'
import { useRef, type FC } from 'react'
import { getColorCSS } from '../color/color.js'
import { Box } from '@mui/material'

interface EntityIconProps {
  entity: Pick<Entity, 'type'>
  size?: 'small' | 'medium' | 'large'
  /** If true, show the icon in the entity color, also when color is specified. @default true */
  active?: boolean
  DefaultIcon?: FC<{ className?: string }>
}

export const EntityIcon: FC<EntityIconProps> = props => {
  const { entity, active = true, size = 'medium', DefaultIcon = Page } = props
  const { icon: Icon, materialColor: color } = useElementTypeMedia(entity.type)
  const ref = useRef<SVGSVGElement>(null)

  const iconColor = active ? getColorCSS(color) : 'inherit'

  return entity ? (
    <Box sx={{ color: iconColor }}>
      <Icon
        ref={ref}
        sx={{
          fontSize: size === 'small' ? 16 : size === 'medium' ? 24 : 32,
          color: iconColor,
        }}
      />
    </Box>
  ) : (
    <DefaultIcon />
  )
}
